import { StyleSheet } from 'react-native-unistyles';
import { useQuery } from 'urql';
import Box from '@/components/UI/Box';
import Chip from '@/components/UI/Chip';
import { graphql } from '@/gql/graphql';

const GetTagGroups = graphql(/* GraphQL */ `
  query GetTagGroups {
    tag_group(order_by: { title: asc }) {
      id
      title
    }
  }
`);

type TagGroupSelectProps = {
  selected: string[];
  onPress: (id: string) => void;
};

export default function TagGroupSelect({
  selected,
  onPress,
}: TagGroupSelectProps) {
  const [{ data: tagGroupData }] = useQuery({
    query: GetTagGroups,
  });

  const tagGroups = tagGroupData?.tag_group;

  return (
    <Box
      direction="horizontal"
      flexWrap="wrap"
      style={style.container}
      testID="TagGroup"
    >
      {tagGroups?.map((tagGroup) => {
        const isChecked = selected.includes(tagGroup.id);

        return (
          <Chip
            key={tagGroup.id}
            value={isChecked}
            label={tagGroup.title || ''}
            onValueChange={() => onPress(tagGroup.id)}
            style={style.chip}
          />
        );
      })}
    </Box>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    gap: theme.size(1),
  },
  chip: {
    maxWidth: theme.size(56),
    paddingHorizontal: theme.size(4),
    paddingVertical: theme.size(2),
  },
}));
